import React from 'react'
import { Helmet } from 'react-helmet'
import Breadcrumb from '../components/Breadcrumb'
import SrServices from '../components/SrServices'
import SrTwoServiceArea from '../components/SrTwoServiceArea'
import SrServiceTagArea from '../components/SrServiceTagArea'
import SrServiceFaq from '../components/SrServiceFaq'

const Services = () => {
  return (
    <>
    <Helmet>
      <title>Our Services - Om Softwares | Web Development, SEO & Social Media Marketing</title>
      <meta name="description" content="Explore Om Softwares' full range of services: web development, SEO, social media marketing, digital marketing, visual branding, and e-commerce solutions in Nangal, Punjab." />
      <meta property="og:title" content="Our Services - Om Softwares" />
      <meta property="og:description" content="Web development, SEO, social media marketing, digital marketing, visual branding, and e-commerce solutions." />
      <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      <meta property="og:url" content="https://omsoftwares.in/services" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our Services - Om Softwares" />
      <meta name="twitter:description" content="Web development, SEO, social media marketing, digital marketing, visual branding." />
      <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
    </Helmet>
    <main>
      <Breadcrumb name="Our Services"/>
      <SrServices/>
      <SrTwoServiceArea/>
      <SrServiceTagArea/>
      <SrServiceFaq/>
    </main>
    </>
  )
}

export default Services
